(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kalvur-flame-product"] && !Shopify.designMode) return;
  try {
    
function initKalvur(){document.querySelectorAll('[data-kv-product]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const form=root.querySelector('.kv-form'),qty=form.querySelector('[name="quantity"]'),atc=form.querySelector('[name="add"]'),err=root.querySelector('[data-kv-error]'),img=root.querySelector('.kv-image'),dialog=root.querySelector('[data-kv-dialog]');root.querySelector('[data-kv-minus]').addEventListener('click',()=>{qty.value=Math.max(1,(parseInt(qty.value)||1)-1)});root.querySelector('[data-kv-plus]').addEventListener('click',()=>{qty.value=(parseInt(qty.value)||1)+1});root.querySelectorAll('[data-kv-image]').forEach(btn=>btn.addEventListener('click',()=>{img.src=btn.dataset.kvImage;img.removeAttribute('srcset');img.style.objectFit=btn.dataset.kvFit||'cover';root.querySelector('.kv-main-image').classList.toggle('is-crop',btn.dataset.kvCrop==='true');root.querySelectorAll('[data-kv-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===btn)));dialog.querySelector('img').src=btn.dataset.kvImage}));root.querySelector('[data-kv-zoom]').addEventListener('click',()=>dialog.showModal());root.querySelector('[data-kv-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});const variant=root.querySelector('[data-kv-variant]');variant?.addEventListener('change',()=>{const opt=variant.selectedOptions[0];root.querySelector('[data-kv-price]').textContent=opt.dataset.price;root.querySelector('[data-kv-sticky-price]').textContent=opt.dataset.price;atc.disabled=opt.dataset.available!=='true';atc.textContent=atc.disabled?atc.dataset.sold:atc.dataset.label;const url=new URL(location.href);url.searchParams.set('variant',opt.value);history.replaceState({},'',url)});form.addEventListener('submit',async e=>{
  e.preventDefault();
  if(atc.disabled)return;
  err.hidden=true;atc.disabled=true;atc.textContent=atc.dataset.adding;
  const stickyButton=root.querySelector('[data-kv-sticky-add]');
  if(stickyButton)stickyButton.disabled=true;
  let deferred;
  try {
    const {CartLinesUpdateEvent}=await import('@shopify/events');
    const data=new FormData(form);
    const sectionIds=[...document.querySelectorAll('cart-items-component[data-section-id]')].map(el=>el.dataset.sectionId);
    data.set('sections',[...new Set(sectionIds)].join(','));
    data.set('sections_url',location.pathname);
    deferred=CartLinesUpdateEvent.createPromise();
    deferred.promise.catch(()=>{});
    root.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:String(data.get('id')),quantity:Number(data.get('quantity'))||1}],promise:deferred.promise}));
    const response=await fetch(form.action+'.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
    const result=await response.json();
    if(!response.ok)throw new Error(result.description||root.dataset.error);
    const cartResponse=await fetch(root.dataset.cartUrl+'.js',{headers:{Accept:'application/json'}});
    if(!cartResponse.ok)throw new Error(root.dataset.error);
    const cart=await cartResponse.json();
    deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,sections:result.sections,source:'kalvur-product',didError:false}});
  } catch(error) {
    deferred?.reject(error);err.textContent=error.message||root.dataset.error;err.hidden=false;
  } finally {
    atc.disabled=variant?variant.selectedOptions[0].dataset.available!=='true':false;
    atc.textContent=atc.disabled?atc.dataset.sold:atc.dataset.label;
    if(stickyButton)stickyButton.disabled=atc.disabled;
  }
});root.querySelector('[data-kv-sticky-add]')?.addEventListener('click',()=>form.requestSubmit());const sticky=root.querySelector('[data-kv-sticky]');const updateSticky=()=>{sticky.hidden=form.getBoundingClientRect().bottom>0};const observer=new IntersectionObserver(updateSticky,{threshold:[0,1]});observer.observe(form);document.addEventListener('scroll',updateSticky,{passive:true,capture:true});window.addEventListener('resize',updateSticky,{passive:true});document.addEventListener('theme-drawer:close',()=>requestAnimationFrame(updateSticky));updateSticky();});}initKalvur();document.addEventListener('shopify:section:load',initKalvur);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
